// LanguageSwitch.tsx
// Compact "EN | DE" toggle for the header (desktop) and the mobile menu.
import React from "react";
import { LANGS, useLang } from "./lang";
import { useUi } from "./ui";
import { FONT_MONO } from "theme/fonts";

const LanguageSwitch: React.FC<{ accentRgb: string; compact?: boolean }> = ({ accentRgb, compact = false }) => {
  const { lang, setLang } = useLang();
  const t = useUi();
  return (
    <div
      role="group"
      aria-label={t.header.language}
      style={{
        display: "inline-flex", alignItems: "center", flexShrink: 0,
        border: `1px solid rgba(${accentRgb},0.35)`, borderRadius: 8,
        padding: 2, gap: 2,
      }}
    >
      {LANGS.map(l => {
        const active = l === lang;
        return (
          <button
            key={l}
            type="button"
            onClick={() => setLang(l)}
            aria-pressed={active}
            lang={l}
            style={{
              fontFamily: FONT_MONO, fontSize: compact ? 11 : 12, letterSpacing: 1,
              padding: compact ? "4px 8px" : "5px 9px", borderRadius: 6, border: "none",
              background: active ? `rgba(${accentRgb},0.22)` : "transparent",
              color: active ? "#ffffff" : "rgba(255,255,255,0.55)",
              fontWeight: active ? 700 : 400, cursor: active ? "default" : "pointer",
              transition: "background 0.15s ease, color 0.15s ease",
            }}
          >
            {l.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitch;
